import React from 'react';
import { default as CheckboxMaterial, CheckboxProps } from '@material-ui/core/Checkbox';
import { makeCheckboxStyles } from 'styles/components/checkbox';

const FormLabel: React.FC<CheckboxProps> = props => {
    const checkboxClasses = makeCheckboxStyles();

    return <CheckboxMaterial classes={checkboxClasses} {...props} />;
};

export default FormLabel;
